import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import InsightDetail from "@/pages/InsightDetail";
import { Toaster } from "@/components/ui/sonner";

const HashScroll = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <HashScroll />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/notas/:slug" element={<InsightDetail />} />
            <Route path="/notes/:slug" element={<InsightDetail />} />
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
